






























































import Vue from "vue";
import Component from "vue-class-component";
import { AUTH_REQUEST } from "@/store/auth/mutation-types";
import AgroFooter from "./components/agro-footer/AgroFooter.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import ResetPasswordModalController from '../login/components/reset-password/ResetPasswordModalController.vue';
import AgroNotificationList from "@/components/agroNotificationList/AgroNotificationList.vue";

@Component({
  name: "Login",
  components: {
    AgroIcons,
    AgroFooter,
    ResetPasswordModalController,
    AgroNotificationList,
  },
})
export default class Login extends Vue {
  private username: string | null = null;
  private password: string | null = null;

  private resetPasswordModal: boolean = false;

  get errorMessage() {
    const { errorMessage } = this.$store.state.auth;

    return this.isError ? errorMessage : null;
  }

  get isError() {
    return this.$store.getters["auth/isError"];
  }

  get notIntegration() {
    return sessionStorage.getItem('integration') !== 'true';
  }

  get isLoading() {
    return (
      this.$store.getters["auth/requestingAuth"] ||
      this.$store.getters["user/requestingUser"]
    );
  }

  public login() {
    const { username, password } = this;
    this.$store.dispatch(`auth/${AUTH_REQUEST}`, { username, password });
  }

  private toggleResetPassword() {
    this.resetPasswordModal = !this.resetPasswordModal;
  }
}
